/* CMI-S UI */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { isEmpty } from 'lodash';
import { getFleetViewData, getFleetViewFilteredData, setFleetViewFilter } from '../../../models/checkerFleetModel/checkerFleetSlice';
import { loadCheckerFleetData, loadCheckerOperators } from '../../../models/checkerFleetModel/checkerFleetThunk';
import {
  DISCREPENCY_OPTIONS,
  DISCREPENCY_WITH_NC_OPTIONS,
} from '../../../utils/constants';
import { updateReasonStatus } from '../../../models/reasonStatusMappingModel/reasonStatusMappingSlice';
import { loadReasonStatusMapping } from '../../../models/reasonStatusMappingModel/reasonStatusMappingThunk';

export const getOperatorFromApi = (dispatch: any) => {
  const operatorPayload: any = {
    conditions: {},
    columns: ['operator_code_icao'],
    distinct: true,
  };
  dispatch(loadCheckerOperators(operatorPayload)());
};

export const getFleetViewDataFromApi = (operator: string[], dispatch: any, metaArg: any = '') => {
  const payload: any = {
    conditions: {},
    operator_code_icao: operator,
    orderBy: ['registration_number'],
    sortType: 'ASC',
  };
  dispatch(loadCheckerFleetData(payload)(metaArg));
};
export const handleAcApplyMethods = (FleetDataResp: any, selectedAcTypes: any) => {
  const acTypeData = FleetDataResp.filter((item: any) => selectedAcTypes.includes(item.ac_type));
  const acSubTypeResp = acTypeData.map((item: any) => item.ac_subtype).filter((item: any) => item);
  const acSubTypeUnique = acSubTypeResp.filter((value: any, index: any, array: any) => array.indexOf(value) === index);
  const msnValues = acTypeData.map((item: any) => item.id_aircraft_registration);
  const msnSelected = msnValues.filter((item: string, index: number, array: any) => array.indexOf(item) === index);
  return { acTypeData, acSubTypeUnique, msnSelected };
};
export const handleAcApply = (selectedAcTypes: any, checkerState: any, dispatch: any) => {
  const FleetDataResp = checkerState.data[checkerState.fleet_view_filter_selected?.selected_operator[0]] || [];
  const { acSubTypeUnique, msnSelected, acTypeData } = handleAcApplyMethods(FleetDataResp, selectedAcTypes);
  const filterValue = {
    ...checkerState.fleet_view_filter_selected,
    selected_aircraft: selectedAcTypes,
    selected_sub_aircraft: acSubTypeUnique,
    selected_msn: msnSelected,
    selected_discrepency: DISCREPENCY_OPTIONS,
    selected_nc_discrepency: DISCREPENCY_WITH_NC_OPTIONS,
  };
  const filterValues = {
    ...checkerState.fleet_view_filters,
    ac_sub_type_list: acSubTypeUnique,
    msn_list: msnSelected,
  };
  dispatch(setFleetViewFilter({ fleet_view_filter_selected: filterValue }));
  dispatch(getFleetViewFilteredData({ visibleData: acTypeData }));
  dispatch(getFleetViewData({ fleet_view_filters: filterValues }));
};
export const handleAcSubApplyMethods = (FleetDataResp: any, selectedAcSubTypes: any) => {
  const acSubTypeData = FleetDataResp.filter((item: any) => selectedAcSubTypes.includes(item.ac_subtype));
  const msnValues = acSubTypeData.map((item: any) => item.id_aircraft_registration);
  const msnSelected = msnValues.filter((item: string, index: number, array: any) => array.indexOf(item) === index);
  return { acSubTypeData, msnSelected };
};
export const handleAcSubApply = (selectedAcSubTypes: any, checkerState: any, dispatch: any) => {
  const FleetDataResp = checkerState.data[checkerState.fleet_view_filter_selected?.selected_operator[0]] || [];
  const { acSubTypeData, msnSelected } = handleAcSubApplyMethods(FleetDataResp, selectedAcSubTypes);
  const filterValue = {
    ...checkerState.fleet_view_filter_selected,
    selected_sub_aircraft: selectedAcSubTypes,
    selected_msn: msnSelected,
    selected_discrepency: DISCREPENCY_OPTIONS,
    selected_nc_discrepency: DISCREPENCY_WITH_NC_OPTIONS,
  };
  const filterValues = {
    ...checkerState.fleet_view_filters,
    msn_list: msnSelected,
  };
  dispatch(getFleetViewFilteredData({ visibleData: acSubTypeData }));
  dispatch(setFleetViewFilter({ fleet_view_filter_selected: filterValue }));
  dispatch(getFleetViewData({ fleet_view_filters: filterValues }));
};
export const handleMsnApplyMethods = (FleetDataResp: any, selectedMsn: any) => {
  const msnData = FleetDataResp.filter((item: any) => selectedMsn.includes(item.id_aircraft_registration));
  return msnData;
};
export const handleMsnApply = (selectedMsn: any, checkerState: any, dispatch: any) => {
  const FleetDataResp = checkerState.data[checkerState.fleet_view_filter_selected?.selected_operator[0]] || [];
  const msnData = handleMsnApplyMethods(FleetDataResp, selectedMsn);
  const filterValue = {
    ...checkerState.fleet_view_filter_selected,
    selected_msn: selectedMsn,
    selected_discrepency: DISCREPENCY_OPTIONS,
    selected_nc_discrepency: DISCREPENCY_WITH_NC_OPTIONS,
  };
  const filterValues = {
    ...checkerState.fleet_view_filters,
  };
  dispatch(getFleetViewFilteredData({ visibleData: msnData }));
  dispatch(setFleetViewFilter({ fleet_view_filter_selected: filterValue }));
  dispatch(getFleetViewData({ fleet_view_filters: filterValues }));
};
/**
 * Filters fleet data based on selected aircraft registrations (MSNs) and status.
 *
 * @param FleetDataResp - The array of fleet data objects to filter.
 * @param selectedStatus - The array of selected status values or objects.
 * @param selectedMsns - The array of selected aircraft registration IDs (MSNs).
 * @returns An array of fleet data objects that match the selected MSNs and status.
 */
export const handleStatusApplyMethods = (FleetDataResp: any, selectedStatus: any, selectedMsns: any) => {
  const filteredMsnDta = FleetDataResp.filter((item: any) => selectedMsns.includes(item.id_aircraft_registration));
  const selectedStatusData = selectedStatus.map((item: any) => item.value || item);
  const statusData = filteredMsnDta.filter((item: any) => selectedStatusData.includes(item.discrepency_result));
  return statusData;
};
export const handleStatusApply = (selectedStatus: any, checkerState: any, dispatch: any) => {
  /**
   * Filters the status options based on the selected status.
   * - If `selectedStatus` is an array with a single empty object, returns `selectedStatus` as-is.
   * - Otherwise, returns the subset of `DISCREPENCY_WITH_NC_OPTIONS` whose `value` matches any value in `selectedStatus`.
   *
   * @param selectedStatus - The currently selected status options, which may be objects or primitive values.
   * @returns The filtered status options based on the selection.
   */
  const filteredStatus = Array.isArray(selectedStatus) && selectedStatus.length === 1 && Object.keys(selectedStatus[0]).length === 0
    ? selectedStatus
    : DISCREPENCY_WITH_NC_OPTIONS.filter((item: any) => selectedStatus
      .map((s: any) => (typeof s === 'object' ? s.value : s))
      .includes(item.value));
  const FleetDataResp = checkerState.data[checkerState.fleet_view_filter_selected?.selected_operator[0]] || [];
  const selectedMsns = checkerState.fleet_view_filter_selected.selected_msn;
  const statusData = handleStatusApplyMethods(FleetDataResp, selectedStatus, selectedMsns);
  const filterValue = {
    ...checkerState.fleet_view_filter_selected,
    selected_discrepency: filteredStatus.filter(
      (item: any) => !(item === 'NC' || item.value === 'NC'),
    ),
    selected_nc_discrepency: filteredStatus,
  };
  dispatch(getFleetViewFilteredData({ visibleData: statusData }));
  dispatch(setFleetViewFilter({ fleet_view_filter_selected: filterValue }));
};

export const checkerReasonStatusMapping = (dispatch: any, reasonStatus: any, checkerState: any) => {
  if (!isEmpty(reasonStatus?.reasonMapping) && !isEmpty(reasonStatus?.statusMapping)) {
    dispatch(updateReasonStatus({
      data: {
        reason_key_mapper: reasonStatus?.reasonMapping,
        status_key_mapper: reasonStatus?.statusMapping,
      },
    }));
  } else {
    dispatch(loadReasonStatusMapping(checkerState.fleet_view_filter_selected?.selected_operator)());
  }
};

export const discrepencySelected = (featureToggle: boolean, checkerState: any) => {
  if (featureToggle) {
    return checkerState.fleet_view_filter_selected?.selected_nc_discrepency;
  }
  return checkerState.fleet_view_filter_selected?.selected_discrepency;
};

export const discrepencySelectedOptions = (featureToggle: boolean, checkerState: any) => {
  if (featureToggle) {
    return checkerState.fleet_view_filters?.status_nc_list;
  }
  return checkerState.fleet_view_filters?.status_list;
};
